// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"8c5190a2","271":"81bd384f","371":"bd2d71ad","407":"e081a428","513":"e7d360a6","816":"137cc01a","860":"7ae4ad92","929":"384ef786"}[chunkId] + ".chunk.js";
};